import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  declare readonly hasIconTarget: boolean;

  declare readonly iconTarget: HTMLElement

  connect() {
    // Load theme from localStorage or fallback to system preference
    const savedTheme = localStorage.getItem("theme")
    if (savedTheme) {
      this.setTheme(savedTheme)
    } else {
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      this.setTheme(prefersDark ? "dark" : "light")
    }
  }

  toggle() {
    const currentTheme = document.documentElement.style.colorScheme || "light"
    const newTheme = currentTheme === "light" ? "dark" : "light"
    this.setTheme(newTheme)
  }

  private setTheme(theme: string) {
    document.documentElement.style.colorScheme = theme
    localStorage.setItem("theme", theme)
    this.updateIcon(theme)
  }

  private updateIcon(theme: string) {
    if (this.hasIconTarget) {
      this.iconTarget.textContent = theme === "dark" ? "☀️" : "🌙"
    }
  }
}
